<template>
    <div class="lc">
        <div ref="cmain1" class="cmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope69",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
        titleMain: {
            type: String,
            default: "类型",
        },
    },
    data() {
        return {
            title: "scope69-【组件】数图样式-完成",
            timer: null,
            defaultdata: [
                {
                    value1: "分类一",
                    value2: "42",
                    value3: [] || "数据",
                    value4: "",
                },
                {
                    value1: "分类二",
                    value2: "18",
                    value3: [] || "数据",
                },
                {
                    value1: "分类三",
                    value2: "5",
                    value3: [] || "数据",
                },
                {
                    value1: "分类四",
                    value2: "3",
                    value3: [] || "数据",
                },
                {
                    value1: "小分类一",
                    value2: "4",
                    value3: [] || "数据",
                    value5: "分类一",
                },
                {
                    value1: "小分类二",
                    value2: "5",
                    value3: [] || "数据",
                    value5: "分类一",
                },
                {
                    value1: "小分类三",
                    value2: "1",
                    value3: [] || "数据",
                    value5: "分类一",
                },
                {
                    value1: "小分类四",
                    value2: "7",
                    value3: [] || "数据",
                    value5: "分类二",
                },
                {
                    value1: "小分类五",
                    value2: "2",
                    value3: [] || "数据",
                    value5: "分类二",
                },
                {
                    value1: "小分类六",
                    value2: "2",
                    value3: [] || "数据",
                    value5: "分类三",
                },
                {
                    value1: "小分类七",
                    value2: "2",
                    value3: [] || "数据",
                    value5: "分类三",
                },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "数值", key: "value2" },
                { name: "单位", key: "value4" },
                { name: "父分类", key: "value5" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            config: {},
            autoTimePaused: false,
        };
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                this.defaultdata = n;
                this.TdrawTreemap();
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
            this.TdrawTreemap();
        },
    },
    methods: {
        ...methods,
        TdrawTreemap() {
            clearInterval(this.timer);
            this.timer = null;
            var echarts = require("echarts");
            var TmyChart = echarts.init(this.$refs.cmain1);
            const colors = ["#0f68f1"];
            let chartdata = []
            this.defaultdata.forEach(item => {
                if (item.value5) {
                    let cindex = chartdata.findIndex(del => del.value1 == item.value5)
                    if (!chartdata[cindex].value3) {
                        chartdata[cindex].value3 = []
                    }
                    chartdata[cindex].value3.push(item)
                } else {
                    chartdata.push(item)
                }
            })
            // console.log('___chartdata', chartdata)
            let vdata = chartdata.map((item, i) => {
                return {
                    name: item.value1,
                    value: +item.value2,
                    children: (item.value3 && item.value3.length) ? item.value3.map((item, i) => {
                        return {
                            name: item.value1,
                            value: +item.value2,
                            itemStyle: { color: colors[i % colors.length] },
                        };
                    }) : [],
                    itemStyle: { color: colors[i % colors.length] },
                };
            });
            let unit = this.defaultdata[0].value4 || '';

            // 定义配置项
            var Toption = {
                tooltip: {
                    trigger: "item",
                },
                color: ["#0f68f1"],
                series: [
                    {
                        name: this.titleMain ? this.titleMain : "",
                        type: "treemap",
                        width: "435px",
                        height: "100%",
                        data: vdata.map((item) => item),
                        leafDepth: 1,
                        visibleMin: 0,
                        colorMappingBy: "value",
                        levels: [
                            {
                                colorSaturation: [0.3, 0.6],
                                itemStyle: {
                                    normal: {
                                        borderColorSaturation: 0,
                                        gapWidth: 10,
                                        borderWidth: 2,
                                    },
                                },
                            },
                            {
                                colorSaturation: [0.3, 0.5],
                                itemStyle: {
                                    normal: {
                                        borderColorSaturation: 0,
                                        gapWidth: 6,
                                    },
                                },
                            },
                            {
                                colorSaturation: [0.3, 0.5],
                            },
                        ],
                        label: {
                            color: "#CBD8DE",
                            lineHeight: 20,
                            fontWeight: "400",
                            fontSize: "14",
                            formatter: (params) => {
                                let newparams =
                                    params.name.length > 9
                                        ? params.name.slice(0, 9) + "..."
                                        : params.name;
                                return params.value + unit + "\n" + newparams;
                            },
                        },
                    },
                ],
            };

            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(() => {
                if (this.autoTimePaused) return;
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000);
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.TdrawTreemap();
    },
};
</script>

<style scoped lang="scss">
.lc {
    width: 435px;
    height: 240px;
    display: flex;
    position: relative;
    padding: 10px 0;
    overflow: hidden;
}

.cmain {
    width: 100%;
    height: 100%;
}
</style>